

<template>
    <div > 
        <Nav></Nav>
        
        <div class="d-flex flex-column PayImgContainer mx-auto">
            <img 
                class="PayImg mx-auto"
                src="../../assets/images/FinishNoWord.jpg"
                width="300"
            />
            <span class="payWord OrangeWord">付款失敗！</span>
        <div class="OrangeWord mx-auto">{{message}}</div>
        </div>
    </div>
</template>
<script>
import Nav from '@/components/Nav'
import {app} from '@/main'
import Vue from 'vue'
import axios from 'axios'
// import moment from 'moment'


export default {
    name: 'PayFail',
    components:{Nav},
    data () {
        return {
            showLoading:'',
            VerificationCode:'',
            message:'',
        }
    },
    mounted(){
        

    },
    methods:{
        GoPay(){

        },
    },
    created(){
        this.message = this.$route.params.message
        //先get網址的內容

    }
}
</script>


// WEBPACK FOOTER //
// src/components/Pay/PayFail.vue